/* Dutch'D luxe layer (fase 14): calmer product zoom + Studio / Model switch */
(function () {
  'use strict';

  /* ---------- 1. Product zoom: fit the screen, one calm step, no blur ---------- */
  var MAX_STEP = 1.6; // largest zoom = 1.6x the photo fitted to the screen

  function patchPhotoSwipe(ns) {
    if (!ns || !ns.PhotoSwipe || !ns.PhotoSwipe.default || ns.PhotoSwipe.default.__ddPatched) return;
    var Original = ns.PhotoSwipe.default;
    function Calm(el, ui, items, options) {
      var vw = window.innerWidth, vh = window.innerHeight;
      items = (items || []).map(function (it) {
        if (!it || !it.w || !it.h) return it;
        var copy = {};
        for (var k in it) copy[k] = it[k];
        var fit = Math.min(vw / it.w, vh / it.h);
        var target = fit * MAX_STEP;
        if (target < 1) {
          copy.w = Math.round(it.w * target);
          copy.h = Math.round(it.h * target);
        }
        if (copy.src && copy.src.indexOf('width=') === -1) {
          var px = Math.min(2400, Math.round(copy.w * (window.devicePixelRatio || 1)));
          copy.src = copy.src + (copy.src.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
        }
        return copy;
      });
      options = options || {};
      options.maxSpreadZoom = 1.2;
      options.getDoubleTapZoom = function (isMouse, item) {
        return item.initialZoomLevel < 1 ? 1 : item.initialZoomLevel * 1.25;
      };
      return new Original(el, ui, items, options);
    }
    Calm.prototype = Original.prototype;
    Calm.__ddPatched = true;
    // the module object is frozen, so swap in a new holder object
    ns.PhotoSwipe = { default: Calm };
  }
  // the theme loads PhotoSwipe lazily and reads it once, right after loading:
  // catch the moment window.themePhotoswipe is set and patch it straight away
  if (window.themePhotoswipe) {
    patchPhotoSwipe(window.themePhotoswipe);
  } else {
    try {
      var held;
      Object.defineProperty(window, 'themePhotoswipe', {
        configurable: true, enumerable: true,
        get: function () { return held; },
        set: function (v) { held = v; try { patchPhotoSwipe(v); } catch (e) {} }
      });
    } catch (e) {}
  }

  /* ---------- 2. Studio / Model switch on collection pages ---------- */
  // every page opens in Studio (not every product has a model photo); the choice only lasts on this page
  var currentView = 'studio';
  try { localStorage.removeItem('ddProductView'); } catch (e) {}
  function readView() { return currentView; }
  function saveView(v) { currentView = v; }

  function loadLayer(layer) {
    if (!layer || layer.dataset.ddLoaded) return;
    var src = layer.getAttribute('data-dd-bg');
    if (!src) return;
    layer.style.backgroundImage = 'url("' + src + '")';
    layer.dataset.ddLoaded = '1';
  }

  function applyView(view) {
    var model = view === 'model';
    document.documentElement.classList.toggle('dd-view-model', model);
    document.querySelectorAll('[data-dd-view] button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-dd-view-set') === view ? 'true' : 'false');
    });
    if (model) document.querySelectorAll('.dd-model-layer').forEach(loadLayer);
  }

  function initView() {
    var toggles = document.querySelectorAll('[data-dd-view]');
    if (!toggles.length) return;
    var hasModel = !!document.querySelector('.dd-model-layer');
    toggles.forEach(function (t) {
      t.hidden = !hasModel;
      var def = t.getAttribute('data-dd-view-default') || 'studio';
      if (!t.dataset.ddBound) {
        t.dataset.ddBound = '1';
        t.addEventListener('click', function (e) {
          var b = e.target.closest('[data-dd-view-set]');
          if (!b) return;
          var v = b.getAttribute('data-dd-view-set');
          saveView(v);
          applyView(v);
        });
      }
      applyView(readView() || def);
    });
  }

  // load the other photo on first hover
  document.addEventListener('mouseover', function (e) {
    var c = e.target.closest && e.target.closest('.product-grid-item__container');
    if (c) loadLayer(c.querySelector('.dd-model-layer'));
  }, { passive: true });


  /* ---------- 3. Colour swatches on collection cards: dominant colour of each shoe photo ---------- */
  var CKEY = 'ddSwatchColours2';
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CKEY) || '{}') || {}; } catch (e) { cache = {}; }
  function saveCache() { try { sessionStorage.setItem(CKEY, JSON.stringify(cache)); } catch (e) {} }

  // Returns one colour, or two for a clearly two-tone shoe. Only the upper part of
  // the shoe is sampled, so a white sole doesn't win over a black upper.
  function dominant(img) {
    var S = 60, c = document.createElement('canvas');
    c.width = S; c.height = Math.round(S * img.naturalHeight / img.naturalWidth) || S;
    var W = c.width, H = c.height, g = c.getContext('2d');
    g.drawImage(img, 0, 0, W, H);
    var d = g.getImageData(0, 0, W, H).data, bg = [d[0], d[1], d[2]];
    function fg(i) { return Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]) >= 36; }
    var y0 = H, y1 = 0, x, y, i;
    for (y = 0; y < H; y++) for (x = 0; x < W; x++) if (fg((y * W + x) * 4)) { if (y < y0) y0 = y; if (y > y1) y1 = y; }
    if (y1 <= y0) return null;
    var cut = y0 + (y1 - y0) * 0.62, B = {};
    for (y = y0; y <= cut; y++) for (x = 0; x < W; x++) {
      i = (y * W + x) * 4;
      if (!fg(i)) continue;
      var k = (d[i] >> 5) + ',' + (d[i + 1] >> 5) + ',' + (d[i + 2] >> 5);
      var o = B[k] || (B[k] = { n: 0, r: 0, g: 0, b: 0 });
      o.n++; o.r += d[i]; o.g += d[i + 1]; o.b += d[i + 2];
    }
    var arr = Object.keys(B).map(function (k) { return B[k]; }).sort(function (a, b) { return b.n - a.n; });
    if (!arr.length) return null;
    function col(o) { return 'rgb(' + Math.round(o.r / o.n) + ',' + Math.round(o.g / o.n) + ',' + Math.round(o.b / o.n) + ')'; }
    var a = arr[0], s = arr[1], res = [col(a)];
    if (s && s.n > a.n * 0.45) {
      var dl = Math.abs(a.r / a.n - s.r / s.n) + Math.abs(a.g / a.n - s.g / s.n) + Math.abs(a.b / a.n - s.b / s.n);
      if (dl > 90) res.push(col(s));
    }
    return res;
  }

  function apply(el, c) {
    el.style.backgroundColor = c[0];
    el.style.backgroundImage = c[1] ? 'linear-gradient(135deg,' + c[0] + ' 50%,' + c[1] + ' 50%)' : 'none';
    el.classList.add('is-solid');
  }

  function paint(el) {
    var src = el.getAttribute('data-dd-img');
    if (!src || el.dataset.ddPainted) return;
    el.dataset.ddPainted = '1';
    if (cache[src]) { apply(el, cache[src]); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var col = dominant(img);
        if (col) { cache[src] = col; saveCache(); apply(el, col); }
      } catch (e) { /* keep the photo crop */ }
    };
    img.src = src;
  }

  function initSwatches(root) {
    var list = (root || document).querySelectorAll('.dd-swatch[data-dd-img]:not([data-dd-painted])');
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) { list.forEach(paint); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.unobserve(en.target); paint(en.target); } });
    }, { rootMargin: '300px' });
    list.forEach(function (el) { io.observe(el); });
  }

  /* ---------- 4. Tap a colour square: show that colour on the card (tap again to open it) ---------- */
  function setText(el, txt) { if (el) el.textContent = txt; }
  function swapCard(sw) {
    var card = sw.closest('.product-grid-item');
    if (!card) return;
    var box = sw.closest('.dd-swatches');
    var d = sw.dataset;
    var original = sw.classList.contains('is-original');

    // image
    var imgs = card.querySelector('.product-grid-item__images');
    if (imgs && d.ddSrc) {
      var layer = imgs.querySelector('.dd-swap-layer');
      if (!layer) { layer = document.createElement('div'); layer.className = 'dd-swap-layer'; layer.setAttribute('aria-hidden', 'true'); imgs.appendChild(layer); }
      if (original) { card.classList.remove('dd-swapped'); }
      else {
        var pre = new Image();
        pre.onload = pre.onerror = function () { layer.style.backgroundImage = 'url("' + d.ddSrc + '")'; card.classList.add('dd-swapped'); };
        pre.src = d.ddSrc;
      }
    }

    // links and title
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.classList.contains('dd-swatch')) return;
      a.setAttribute('href', d.ddUrl);
      if (a.hasAttribute('aria-label')) a.setAttribute('aria-label', d.ddTitle);
    });
    setText(card.querySelector('.product__grid__title'), d.ddTitle);

    // price row
    var row = card.querySelector('.product__grid__price');
    if (row) {
      row.textContent = '';
      var price = document.createElement('span');
      price.className = 'price' + (d.ddCompare ? ' on-sale' : '');
      price.textContent = d.ddPrice;
      row.appendChild(price);
      if (d.ddCompare) {
        var cmp = document.createElement('span'); cmp.className = 'compare-at'; cmp.textContent = d.ddCompare; row.appendChild(cmp);
        var pct = document.createElement('span'); pct.className = 'product__grid__sale-pct'; pct.textContent = '-' + d.ddPct + '%';
        if (box && box.dataset.ddSalecolor) pct.style.color = box.dataset.ddSalecolor;
        row.appendChild(pct);
      }
    }

    // sold out line
    var info = card.querySelector('.product__grid__info > a');
    var sold = card.querySelector('.product__grid__price__sold');
    if (d.ddAvailable === 'true') { if (sold) sold.hidden = true; }
    else if (info) {
      if (!sold) { sold = document.createElement('p'); sold.className = 'product__grid__price__sold'; sold.innerHTML = '<em></em>'; info.appendChild(sold); }
      sold.querySelector('em').textContent = (box && box.dataset.ddSoldout) || '';
      sold.hidden = false;
    }

    // which square is active
    if (box) box.querySelectorAll('.dd-swatch').forEach(function (s) { s.classList.toggle('is-current', s === sw); });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('.dd-swatch');
    if (!sw || sw.classList.contains('is-current') || !sw.dataset.ddUrl) return; // the active colour opens its page
    e.preventDefault();
    swapCard(sw);
  });

  function boot() {
    initView();
    initSwatches();
    // the collection grid is re-rendered after filtering/sorting: keep the chosen view
    var grid = document.querySelector('[data-products-grid]');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () {
        var t = document.querySelector('[data-dd-view]');
        if (t) {
          t.hidden = !document.querySelector('.dd-model-layer');
          applyView(readView() || t.getAttribute('data-dd-view-default') || 'studio');
        }
        initSwatches(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
